import { Flex, createStyles } from '@mantine/core';
import { IconQuestionMark } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import Image from '~/domains/common/components/Image/Image';
import { Text } from '~/domains/common/components/Text/Text';

type PickImageProps = {
  name: string;
  logo: string;
  shouldMakePicks?: boolean;
};

const useStyles = createStyles((theme) => ({
  root: {
    borderRadius: theme.radius.sm,
    background: theme.colors.gray[3],
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 2,
    marginTop: 2,
  },
  makePicks: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    marginBottom: 2,
    marginTop: 2,
    borderColor: theme.colors.red[6],
    color: theme.colors.red[6],
  },
  image: {
    objectFit: 'contain',
  },
  icon: {
    stroke: theme.colors.dark[8],
  },
}));

function PickImage({ name, logo, shouldMakePicks }: PickImageProps) {
  const { t } = useTranslation('contest');
  const { classes } = useStyles();

  if (name && logo) {
    return (
      <Image
        height={32}
        width={32}
        src={logo}
        alt={name}
        className={classes.image}
        fallbackComponent={
          <Flex h={32} w={32} className={classes.root}>
            <IconQuestionMark className={classes.icon} size={16} />
          </Flex>
        }
      />
    );
  }

  if (shouldMakePicks) {
    return (
      <Text h={28} w={28} className={classes.makePicks} variant="web-subhead-xx-small">
        {t('game.common.makePicks')}
      </Text>
    );
  }

  return <Flex h={28} w={28} className={classes.root} />;
}

export default PickImage;
